import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  report: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    storeContractReport(state, action) {
      state.report = action.payload;
    },
    clearReport(state) {
      state.report = null;
    },
  },
});

export const { storeContractReport, clearReport } = reportSlice.actions;
export default reportSlice.reducer;
